import { render } from "./AddSubMeter.vue?vue&type=template&id=2b4787f4"
import script from "./AddSubMeter.vue?vue&type=script&lang=js"
export * from "./AddSubMeter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__